module.exports = __webpack_public_path__ + "img/portrait_960.ae50de2f.webp";